import { exportToExcel } from '../../../../../../../../lib/designSystem/DataExporter/utils/exportToExcel';
import { ExportProps, Headers, Prospect } from '../../../Prospects.types';

// INCOMPLETE: 12M, 6M, 3M, 1M COLUMNS ARE NOT CORRECT AS FROM PROSPECT COUNTS X DAYS AND NOT Y PREVIOUS MONTHS
export const exportFull = async ({
  prospectsMainTable: prospectsMainTable,
  monthlyData: monthlyData,
  orderedMonths: orderedMonths,
}: ExportProps) => {
  if (!orderedMonths) return;
  const invertedMonths = [...orderedMonths].reverse();

  const getAllPayersFactorings = (prospect: Prospect) => {
    const payers: Record<string, any> = {};
    const factorings: Record<string, any> = {};
    const prospectMonthlyData = monthlyData[prospect.businessIdentifier];

    for (let i = 0; i < 12; i++) {
      const month = invertedMonths[i];

      const payersInMonth = prospectMonthlyData.byStakeholder[month];
      for (const payer of payersInMonth) {
        if (payers[payer.identifier]) {
          payers[payer.identifier]['12M'] += i < 12 ? payer.amount : 0;
          payers[payer.identifier]['6M'] += i < 6 ? payer.amount : 0;
          payers[payer.identifier]['3M'] += i < 3 ? payer.amount : 0;
          payers[payer.identifier]['1M'] += i < 1 ? payer.amount : 0;
        } else {
          payers[payer.identifier] = {
            businessName: payer.name,
            type: 'Deudor',
            businessIdentifier: payer.identifier,
            '12M': i < 12 ? payer.amount : 0,
            '6M': i < 6 ? payer.amount : 0,
            '3M': i < 3 ? payer.amount : 0,
            '1M': i < 1 ? payer.amount : 0,
          };
        }
      }

      const factoringsInMonth = prospectMonthlyData.byFactoring[month];
      for (const factoring of factoringsInMonth) {
        if (factorings[factoring.identifier]) {
          factorings[factoring.identifier]['12M'] +=
            i < 12 ? factoring.amount : 0;
          factorings[factoring.identifier]['6M'] +=
            i < 6 ? factoring.amount : 0;
          factorings[factoring.identifier]['3M'] +=
            i < 3 ? factoring.amount : 0;
          factorings[factoring.identifier]['1M'] +=
            i < 1 ? factoring.amount : 0;
        } else {
          factorings[factoring.identifier] = {
            businessName: factoring.name,
            type: 'Factoring',
            businessIdentifier: factoring.identifier,
            '12M': i < 12 ? factoring.amount : 0,
            '6M': i < 6 ? factoring.amount : 0,
            '3M': i < 3 ? factoring.amount : 0,
            '1M': i < 1 ? factoring.amount : 0,
          };
        }
      }
    }

    const payersSorted = Object.values(payers).sort(
      (a, b) => b['12M'] - a['12M'],
    );

    const factoringsSorted = Object.values(factorings).sort(
      (a, b) => b['12M'] - a['12M'],
    );

    return { payersSorted, factoringsSorted };
  };

  const headers: Headers = [
    { key: 'businessName', label: 'Razón Social' },
    { key: 'type', label: 'Tipo' },
    { key: 'businessIdentifier', label: 'Rut' },
    { key: '12M', label: '12M' },
    { key: '6M', label: '6M' },
    { key: '3M', label: '3M' },
    { key: '1M', label: '1M' },
  ];
  const data: any[] = [];

  for (const prospect of prospectsMainTable) {
    data.push({
      businessName: prospect.businessName,
      type: 'Prospecto',
      businessIdentifier: prospect.businessIdentifier,
      '12M': prospect['12M'],
      '6M': prospect['6M'],
      '3M': prospect['3M'],
      '1M': prospect['1M'],
    });

    let result: any = {};
    // Get three top payers and factorings by total amount per payer
    result = getAllPayersFactorings(prospect);
    for (const payer of result.payersSorted) {
      data.push(payer);
    }
    for (const factoring of result.factoringsSorted) {
      data.push(factoring);
    }
    data.push({});
  }

  await exportToExcel(data, headers, `Prospectos - Completo.xlsx`);
};
